import { Box, Flex, HStack, Image as ChakraImage, VStack } from '@chakra-ui/react';
import currency from '@common/utility/currency';
import React, { PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';
import { ROUTES } from 'src/apps/invest/config';
import { Investment } from '../../types';
type MobileTableProps = {
  data: Investment[];
};
type LinkRowProps = {
  isSFR: boolean;
  i: number;
  sfrID?: string | null;
};
const LinkRow: React.FC<PropsWithChildren<LinkRowProps>> = ({ isSFR, children, i, sfrID }) => {
  return isSFR ? (
    <HStack
      backgroundColor={i % 2 === 0 ? 'transparent' : 'gray.25'}
      p="10px"
      w={'100%'}
      as={Link}
      to={`${ROUTES.properties}/${sfrID}`}
      justifyContent="space-between">
      {children}
    </HStack>
  ) : (
    <HStack
      backgroundColor={i % 2 === 0 ? 'transparent' : 'gray.25'}
      p="10px"
      w={'100%'}
      as={'a'}
      href={'https://www.concreit.com/strategies/cash-flow'}
      target={'_blank'}
      justifyContent="space-between">
      {children}
    </HStack>
  );
};
export const MobileTable: React.FC<MobileTableProps> = ({ data }) => {
  return (
    <Flex flexDirection="column" mt="40px" flex={1} borderRadius="10px" h={'420px'}>
      <VStack w={'100%'}>
        {data.map((row, i) => {
          const isSFR = Boolean(row.id);
          return (
            <LinkRow isSFR={isSFR} key={`m-investment-${i}`} i={i}>
              <Box display="flex">
                {<ChakraImage w={'60px'} h={'40px'} src={row.photo} />}
                <Box ml="24px">
                  <TextBlock weight="bold">{row.name}</TextBlock>
                  <TextBlock weight="bold" color={'gray.200'}>
                    {row.location}
                  </TextBlock>
                </Box>
              </Box>
              <Box textAlign="end">
                <TextBlock pl={7} weight="bold">
                  {currency.format(row.currentValue, { maximumFractionDigits: 2, minimumFractionDigits: 2 })}
                </TextBlock>
                <TextBlock pl={7} weight="bold" color={'green.400'}>
                  {currency.format(row.income, { maximumFractionDigits: 2, minimumFractionDigits: 2 })}
                </TextBlock>
              </Box>
            </LinkRow>
          );
        })}
        ;
      </VStack>
    </Flex>
  );
};
